import styled from '@emotion/styled';
import {Section} from '../ui/Section';

export const EmptyState = styled(Section)<{isError?: boolean}>`
    color: ${props => (props.isError ? props.theme.error : props.theme.subForeground)};
    font-size: 1.2em;
    text-align: center;
`;
